import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Toggle } from '@checkmarx/cx-ui';
import RoleMappingSection from './roleMappingSection';
import GroupSchemaSettingsSection from './groupSchemaSettingsSection';

@inject('translationsStore') @observer
export default class LdapSynchronizationForm extends Component {

    currentLdapStore = this.props.currentLdapStore;
    ldapValidator = this.props.ldapValidator;
    translations = this.props.translationsStore;
    t = this.translations.translate;

    handleChangeSynchronizationEnabled = e => {

        this.currentLdapStore.setSynchronizationEnabled(e.target.checked);
        this.ldapValidator.setSynchronizationEnabled(e.target.checked);
    }

    render() {

        return (
            <div className='ldap-server-settings-form-main-wrapper'>
                <div className='form-row enable-server'>
                    <Toggle
                        dataCy='tgl-enable-sync'
                        onChange={this.handleChangeSynchronizationEnabled}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        checked={this.currentLdapStore.synchronizationEnabled || false}
                        text={this.currentLdapStore.synchronizationEnabled ? this.t('SYNCHRONIZATION_IS_ENABLED') : this.t('SYNCHRONIZATION_IS_DISABLED')}
                    /> 
                </div>
                <RoleMappingSection 
                    currentLdapStore={this.currentLdapStore}
                    ldapValidator={this.ldapValidator} />
                <GroupSchemaSettingsSection 
                    currentLdapStore={this.currentLdapStore}
                    ldapValidator={this.ldapValidator}
                    ldapServerId={this.props.ldapServerId} />
            </div>
        );

  }
}


// WEBPACK FOOTER //
// ./src/components/ldap/forms/ldapSynchronizationForm.jsx